export default __webpack_public_path__ + "static/media/maths.2c6e2c2d.svg";